/**
 * @class {T.Wizard}
 * @extends {mkE.Base}
 * @param {T.Wizard.Par|Object} [par]
 */
T.Wizard = Class(
	/**
	 * @lends {T.Wizard#}
	 */
	{
		__NAME: 'T.Wizard',

		_currentStep: 0,
		_currentStepItem: null,
		_totalSteps: 0,
		_canContinue: false,
		_canGoBack: false,

		/**
		 * @param {T.Wizard.Par|Object} [par]
		 * @constructs
		 */
		__construct: function(par){
			this.par = par || new T.Wizard.Par();

			this.node = mkE({
				tag: 'div',
				className: 'wizard',
				els: [
					this._contentNode = mkE({
						tag: 'div',
						className: 'content'
					}),
					this._footerNode = mkE({
						tag: 'div',
						className: 'bottom',
						els: [
							this._backButton = mkE({
								tag: 'button',
								className: 'back button-disabled',
								onclick: this._goBack
							}),
							this._bottomContent = mkE({
								tag: 'div',
								className: 'bottom-content'
							}),
							this._nextButton = mkE({
								tag: 'button',
								className: 'button button-pink button-large button-block button-disabled',
								onclick: this._goNext,
								text: D.Lang.get('wizard.continue')
							})
						]
					})
				]
			});

			this._currentStep = par.currentStep || 0;
			if( par.getSteps ){
				this._getSteps = par.getSteps;
			}
			this._onStepChange = par.onStepChange || D.doNothing;
			this._drawStep(this._currentStep);
		},

		setError: function(error) {
			if( this._errorNode ){
				this._errorNode.remove();
			}
			this._errorNode = T.error(error).prepend(this._contentNode);
		},

		_getSteps: function(){
			return [];
		},

		_drawStep: function(step){
			clearNode(this._contentNode);
			clearNode(this._bottomContent);
			let steps = this._getSteps();
			this._totalSteps = steps.length;
			this._currentStepItem = steps[step];
			this._currentStepItem._wizard = this;
			this.drawHeader(steps);
			if( this._currentStepItem.showFooter ){
				this._showFooter();
				if( this._currentStepItem.bottomContent ){
					this.setBottomContent(this._currentStepItem.bottomContent);
				}
			}else{
				this._hideFooter();
			}
			if( this._currentStepItem.canGoBack ){
				this.enableBack();
			}else{
				this.disableBack();
			}
			if( this._currentStepItem.canContinue ){
				this.enableNext();
			}else{
				this.disableNext();
			}
			if( this._currentStepItem.continueText ){
				setNodeText(this._nextButton, this._currentStepItem.continueText);
			}else{
				setNodeText(this._nextButton, D.Lang.get('wizard.continue'));
			}
			let els = '';
			if( this._currentStepItem.getContent instanceof Function ){
				els = this._currentStepItem.getContent();
			}else{
				els = this._currentStepItem.getContent;
			}
			mkE.appendTypeElement(this._contentNode, els);
			this._currentStepItem.setActive();
		},

		drawHeader: function(steps){
			if( this._totalSteps <= 1 ){
				return;
			}
			let count = steps.length;
			let stepsNode = mkE({
				tag: 'div',
				className: 'steps'
			});
			for( let i = 0; i < count; i++ ){
				let caption = '';
				if( steps[i].caption ){
					caption = mkE({
						tag: 'div',
						className: 'step-caption'
					});
					mkE.appendTypeElement(caption, steps[i].caption);
				}
				mkE({
					tag: 'div',
					className: 'step' + (i <= this._currentStep ? ' step-active' : '') + (caption ? ' step-with-caption' : ''),
					els: [
						caption
					],
					onclick: D.closure(this, this._goToStep, i)
				}).append(stepsNode);
			}
			if( this._stepsNode && this._stepsNode.parentNode ){
				D.insertBefore(stepsNode, this._stepsNode);
				this._stepsNode.remove();
			}else{
				stepsNode.append(this._contentNode);
			}
			this._stepsNode = stepsNode;
		},

		_goToStep: function(index){
			if( this._currentStep >= index ){
				this.setStep(index);
				return;
			}
			let steps = this._getSteps();
			for( let i = 0; i < index; i++ ){
				if( !steps[i].canContinue ){
					return;
				}
			}
			this.setStep(index);
		},

		_showFooter: function(){
			this._footerNode.style.display = '';
		},

		_hideFooter: function(){
			this._footerNode.style.display = 'none';
		},

		disableNext: function(){
			addClassName(this._nextButton, 'button-disabled');
			this._canContinue = false;
		},

		enableNext: function(){
			removeClassName(this._nextButton, 'button-disabled');
			this._canContinue = true;
		},

		disableBack: function(){
			addClassName(this._backButton, 'button-disabled');
			this._canGoBack = false;
		},

		enableBack: function(){
			removeClassName(this._backButton, 'button-disabled');
			this._canGoBack = true;
		},

		previousStep: function(){
			let previousStep = this._currentStep - 1;
			if( previousStep < 0 ){
				this._exitWizard();
				return;
			}
			this.setStep(previousStep);
		},

		nextStep: function(){
			let nextStep = this._currentStep + 1;
			if( nextStep >= this._totalSteps ){
				return;
			}
			this.setStep(nextStep);
		},

		setStep: function(index){
			this._currentStep = index;
			this._drawStep(this._currentStep);
			this._onStepChange(this._currentStep, this._currentStepItem);
		},

		_goBack: function(){
			if( !this._canGoBack ){
				return;
			}
			this.previousStep();
		},

		_goNext: function(){
			if( !this._canContinue ){
				return;
			}
			if( !this._currentStepItem.continueAction ){
				this.nextStep();
				return;
			}
			this._currentStepItem.continueAction();
		},

		_exitWizard: function(){
			Section.navigate(this.par.returnUrl || D.url('/'));
		},

		setContinueText: function(text){
			setNodeText(this._nextButton, text);
		},

		setBottomContent(content) {
			clearNode(this._bottomContent);
			mkE.appendTypeElement(this._bottomContent, content);
		}
	},
	mkE.Base
);

/**
 * @class {T.Wizard.Par}
 */
T.Wizard.Par = Class(
	/**
	 * @lends {T.Wizard.Par#}
	 */
	{
		__NAME: 'T.Wizard.Par',

		currentStep: 0,
		getSteps: null,
		returnUrl: null,
		onStepChange: D.doNothing
	}
);

/**
 * @class {T.Wizard.Step}
 * @param {Object} par
 */
T.Wizard.Step = Class(
	/**
	 * @lends {T.Wizard.Step#}
	 */
	{
		__NAME: 'T.Wizard.Step',

		caption: '',
		showFooter: true,
		getContent: '',
		canGoBack: false,
		canContinue: false,
		continueText: '',
		continueAction: null,
		onActivate: D.doNothing,
		bottomContent: '',

		/**
		 * @param {Object} par
		 * @constructs
		 */
		__construct: function(par){
			par = par || {};

			for( let key in par ){
				if( !par.hasOwnProperty(key) ){
					continue;
				}
				this[key] = par[key];
			}
		},

		setActive: function(){
			if( this.onActivate instanceof Function ){
				this.onActivate();
			}
		},

		setCanGoBack: function(v){
			this.canGoBack = v;
			if( v === true ){
				this._wizard.enableBack();
			}else{
				this._wizard.disableBack();
			}
		},

		setCanContinue: function(v){
			this.canContinue = v;
			if( v === true ){
				this._wizard.enableNext();
			}else{
				this._wizard.disableNext();
			}
		},

		setContinueText: function(text){
			this.continueText = text;
			if( this._wizard && this._wizard._currentStepItem === this ){
				this._wizard.setContinueText(text);
			}
		}
	}
);
